import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ChevronLeft",
  "use": "ChevronLeft-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"ChevronLeft\">\n<path d=\"M23.6 24.4L15.4 16l8.2-8.4L20 4 8.4 16 20 28z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol